import type { ScanProfile } from "./types";
import { API_MODE, delay } from "./helpers";
import * as db from "@/lib/mocks/db";
import { paths, type WireScanProfileList } from "./wire";
import { request } from "./http";

/**
 * The menu the DEPLOYMENT publishes — `GET /v1/scan-profiles` (IFC-013, S-166).
 *
 * It used to be a constant in this file: SCS §7's twelve, filtered by a list
 * of ids the client also held. That is the roster back in the client, which
 * invariant 14 and SARD P4 forbid, and the gateway's own source spells out
 * what it costs — "A console that shipped SCS §7's twelve would offer six this
 * deployment refuses, and the user would meet that refusal at launch, after
 * choosing a target, an auth profile and a scope."
 *
 * The client now receives the result without the reasoning, which is the whole
 * arrangement. The mock keeps a copy so both sources have the same SHAPE; it
 * is fixture data and not a fallback — nothing reads it in `http` mode.
 *
 * 2.858: its OWN module, apart from the launch path in `./scans`. The shell
 * (both sidebars, the command palette and the nav filter) reads this menu
 * through 2.854's AI-availability hook, so whatever this module imports ships
 * in the ENTRY chunk that every first load pays for. Imported from `./scans`,
 * it brought the whole launch module and the run parser with it (+4,303 B gzip
 * on the entry, measured on batch-1005a). Keep its imports to the transport:
 * the bundle check asserts the entry holds no module of `scans.ts` or `runs.ts`.
 */
export async function listScanProfiles(): Promise<ScanProfile[]> {
  if (API_MODE === "http") {
    const list = await request<WireScanProfileList>(paths.scanProfiles());
    return (list.items ?? []).map((p) => ({
      id: p.id,
      name: p.name,
      intent: p.intent,
      capabilities: (p.capabilities ?? []).map((c) => ({
        id: c.id,
        narrowing: c.narrowing || undefined,
      })),
    }));
  }
  await delay(100);
  return db.scanProfileMenu.filter((p) => db.publishedScanProfileIds.includes(p.id));
}
